import $ from 'jquery';
import Reflux from 'reflux';
import ChoiceActionsFactory from './choice-actions-factory';
const StoreCache = {};
export default class ChoiceStore extends Reflux.Store {
    constructor(props, allowMultiple = false, questionId) {
        super();
        let state = this.getInitialState();
        this.state = $.extend(state, props);
        this.props = props;
        this.questionId = questionId;
        this.allowMultiple = allowMultiple;
        this.listenables = ChoiceActionsFactory.get(questionId);
    }
    getInitialState() {
        return {
            choiceId: null,
            choiceText: '',
            responseText: null,
            displayOrder: 1,
            correct: true,
            selected: false,
            explanation: '',
            totalAbsoluteResponseCount: 0,
            totalResponses: '0'
        }
    }
    onChange(choice, isSelected) {

        // Sets radio button 'selected' to 'false' if it was previously set to 'true'
        if (!this.allowMultiple && this.state.choiceId != choice.choiceId && this.state.selected) {
            this.props.selected = false;
            this.setState({
                selected: false
            });
        }
        // Sets the radio button that was changed 'selected' to 'true'
        else if (!this.allowMultiple && this.state.choiceId == choice.choiceId && !this.state.selected) {
            this.props.selected = true;
            this.setState({
                selected: true
            })
        }
        // Sets checkbox changes to the new selected state
        else if (this.allowMultiple && this.state.choiceId == choice.choiceId) {
            this.props.selected = isSelected;
            this.setState({
                selected: isSelected
            })
        }
    }
}
ChoiceStore.get = function(choice, allowMultiple = false, questionId){
    const key = `choice[${choice.choiceId}]`;
    if(StoreCache[key]==null || StoreCache[key].listenables.length==0 || StoreCache[key].listenables.length==null ){
        StoreCache[key]=new ChoiceStore(choice, allowMultiple, questionId);
    }
    else{
        StoreCache[key];
    }
    return StoreCache[key];
}


// WEBPACK FOOTER //
// ./medscape_modules/qna/form-components/choices/choice-store.js